import { useEffect, useState } from "react";
import { api } from "@/lib/api";

// Per-page search title / description / heading (defaults generated by the backend, editable in Admin → SEO).
// Fetched once per session and shared by every page.
let cache = null;
let inflight = null;
const listeners = new Set();

export function loadSeoPages() {
  if (cache) return Promise.resolve(cache);
  if (!inflight) {
    inflight = api.get("/seo/pages").then(({ data }) => {
      cache = data.pages || {};
      listeners.forEach((fn) => fn(cache));
      return cache;
    }).catch(() => ({}));
  }
  return inflight;
}

export function useSeoPage(key) {
  const [pages, setPages] = useState(cache);
  useEffect(() => {
    if (cache) { setPages(cache); return undefined; }
    listeners.add(setPages);
    loadSeoPages();
    return () => listeners.delete(setPages);
  }, []);
  return key && pages ? pages[key] || null : null;
}
